import Loading from "../../components/Loading";
import PageLayout from "../../layouts/PageLayout";
import InventoryStep from "./InventoryStep/InventoryStep";
import { useGetRouteState } from "../../utils/route.utils";
import { getJson } from "../../utils/json.utils";
import { useGetAllCarInfoByCarInfoTypeSlug } from "../../utils/carInfo.utils";

export default function VehicleInventoryAddPage({ editItem }) {
  const { data: existVehicle, redirectTo } = useGetRouteState();

  const id = editItem?.id ?? "";

  const editedVehicle = editItem?.attachment ? getJson(editItem.attachment) : "";

  const editInventoryBackPath = editedVehicle?.car?.sku
    ? `/stock-list/${editedVehicle?.car?.sku}/view`
    : "";

  // get all inventory accessories
  const { data: accessories, loading } = useGetAllCarInfoByCarInfoTypeSlug("vehicle-inventory");

  const isLoading = loading;

  const title = `${!!id ? "Edit" : "Add"} Inventory`;

  const backPath = redirectTo ?? editInventoryBackPath ?? "/stock-list";

  const breadCrumbs = [
    {
      name: "Inventory",
      link: backPath
    },
    {
      name: title ?? ""
    }
  ];

  return (
    <PageLayout title={title} breadCrumbs={breadCrumbs}>
      {<Loading loading={isLoading} />}
      {!isLoading && accessories?.length && (
        <InventoryStep
          title={title}
          editItem={editItem}
          existVehicle={existVehicle}
          redirectTo={backPath}
          addAccessories={accessories}
        />
      )}
    </PageLayout>
  );
}
